import CaseStudyData from "assets/files/CaseStudy.json"

export function GetCaseStudyData() {
    return CaseStudyData;
}